import styled from '@emotion/styled';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import { ClassAttributes, createElement, MouseEventHandler } from 'react';
import { FormattedMessage } from 'react-intl';

type Props = ClassAttributes<HTMLElement> & {
  onClickAcceptButton: MouseEventHandler<HTMLElement>;
  onRequestClose: MouseEventHandler<HTMLElement>;
  open?: boolean;
  className?: string;
};

const SubmitDialog = ({ onClickAcceptButton, onRequestClose, open, className }: Props) => {
  return (
    <Dialog open={!!open} onClose={onRequestClose} className={className}>
      <DialogTitle>
        <FormattedMessage id="project_editing_page.creative_submitted.dialog.title" />
      </DialogTitle>

      <DialogContent>
        <DialogContentText>
          <FormattedMessage id="project_editing_page.creative_submitted.dialog.contents" />
        </DialogContentText>
        <DialogContentList>
          <DialogContentText>
            <FormattedMessage id="project_editing_page.creative_submitted.dialog.description1" />
          </DialogContentText>
          <DialogContentText>
            <FormattedMessage id="project_editing_page.creative_submitted.dialog.description2" />
          </DialogContentText>
        </DialogContentList>
      </DialogContent>

      <DialogActions>
        <Button onClick={onRequestClose} variant="contained" color="default">
          <FormattedMessage id="project_editing_page.creative_submitted.dialog.button.cancel_label" />
        </Button>

        <Button onClick={onClickAcceptButton} variant="contained" color="primary">
          <FormattedMessage id="project_editing_page.creative_submitted.dialog.button.ok_label" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const DialogContentList = styled('div')({
  marginTop: 16,
});
export default SubmitDialog;
